import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { 
  ArrowLeft, RotateCw, ChevronLeft, ChevronRight, 
  BookOpen, CheckCircle2, XCircle, Shuffle, Home
} from 'lucide-react';

const flashcardsData = {
  basics: {
    name: 'Temel Kavramlar',
    emoji: '📋',
    color: 'from-blue-500 to-indigo-600',
    cards: [
      { front: 'STAR Tekniği nedir?', back: 'Situation (Durum), Task (Görev), Action (Aksiyon), Result (Sonuç) - Mülakatta deneyimleri anlatma tekniği' },
      { front: 'Kabin Memuru temel görevi?', back: 'Yolcu güvenliği ve konforu sağlamak. Güvenlik HER ZAMAN öncelikli!' },
      { front: 'Open Day nedir?', back: 'Havayollarının toplu mülakat günü. Aynı gün içinde birden fazla aşama geçilir.' },
      { front: 'BMI nedir?', back: 'Body Mass Index - Kilo/Boy² oranı. Havayolları genelde 18-25 arasını kabul eder.' },
      { front: 'Turnaround Time?', back: 'Uçağın iniş ve kalkış arası hazırlık süresi. Low-cost\'ta 25-30 dakika.' },
      { front: 'Grooming standartları?', back: 'Saç, makyaj, tırnak, kıyafet kuralları. Her havayolunun kendine özgü standartları var.' },
      { front: 'Reach Test nedir?', back: 'Üst dolaplara uzanma testi. Genelde 212 cm\'ye uzanabilmek gerekir.' },
      { front: 'Pre-flight briefing?', back: 'Uçuş öncesi ekip toplantısı. Güvenlik, özel yolcular, rota bilgisi paylaşılır.' }
    ]
  },
  safety: {
    name: 'Güvenlik',
    emoji: '🛡️',
    color: 'from-red-500 to-rose-600',
    cards: [
      { front: 'Acil çıkış kapısı açma prosedürü?', back: '1. ARM position kontrol 2. Dışarı bak (yangın/engel) 3. Kolu çek 4. Kapıyı it/çıkar 5. Kaydırağı aktifle' },
      { front: 'Oksijen maskesi kullanımı?', back: 'Önce KENDİ maskeni tak, sonra başkalarına yardım et. Torba şişmese bile oksijen akar.' },
      { front: 'Brace Position nedir?', back: 'Sert iniş pozisyonu. Başı öne eğ, elleri başın arkasına koy veya önündeki koltuğa daya.' },
      { front: 'Type A vs Type C Emergency?', back: 'Type A: Hazırlıklı acil (zaman var). Type C: Ani acil (30 saniye içinde).' },
      { front: 'Fire Triangle?', back: 'Yangın için 3 element: Isı + Oksijen + Yakıt. Birini kaldır = yangın söner.' },
      { front: 'PBE nedir?', back: 'Protective Breathing Equipment - Duman/yangında ekibin kullandığı solunum cihazı.' },
      { front: 'Ditching nedir?', back: 'Suya acil iniş. Life vest + Raft + Survival kit kullanılır.' },
      { front: 'ABP kimdir?', back: 'Able-Bodied Passenger - Acilde yardım edebilecek sağlıklı yolcu. Acil çıkış yanına oturtulur.' }
    ]
  },
  service: {
    name: 'Hizmet',
    emoji: '☕',
    color: 'from-emerald-500 to-teal-600',
    cards: [
      { front: 'CIP/VIP farkı?', back: 'CIP: Commercially Important (iş adamı). VIP: Very Important (devlet adamı, ünlü).' },
      { front: 'UM nedir?', back: 'Unaccompanied Minor - Refakatsiz çocuk yolcu. Özel prosedürler uygulanır.' },
      { front: 'WCHC/WCHR/WCHS?', back: 'Wheelchair codes. C: Cabin (tamamen bağımlı), R: Ramp (merdiven çıkamaz), S: Steps (az yardım).' },
      { front: 'Special Meal kodları?', back: 'VGML: Vegan, VLML: Vegetarian, KSML: Kosher, MOML: Muslim meal, DBML: Diabetic' },
      { front: 'Upselling nedir?', back: 'Duty-free, upgrade, ekstra hizmet satışı. Müşteri ihtiyacını anlayarak teklif et.' },
      { front: 'Delay nasıl yönetilir?', back: 'Düzenli anons, su/atıştırmalık ikramı, empati göster, güncel bilgi ver.' },
      { front: 'Compensation hakkı?', back: '3+ saat gecikme = yemek/içecek. 5+ saat = konaklama (AB kuralları).' },
      { front: 'First Class vs Business?', back: 'First: En premium, tam yatak, özel lounge. Business: Yatar koltuk, öncelikli hizmet.' }
    ]
  },
  airlines: {
    name: 'Havayolları',
    emoji: '✈️',
    color: 'from-purple-500 to-pink-600',
    cards: [
      { front: 'THY kaç ülkeye uçuyor?', back: '126+ ülke, 340+ destinasyon. Dünyanın en çok ülkesine uçan havayolu.' },
      { front: 'THY hub\'ları?', back: 'Ana hub: İstanbul Havalimanı. Diğer: Sabiha Gökçen, Ankara, Antalya, İzmir.' },
      { front: 'Pegasus modeli?', back: 'Low-cost carrier. Hızlı turnaround, optimize edilmiş maliyet, uygun fiyat.' },
      { front: 'SunExpress ortakları?', back: 'THY (%50) + Lufthansa (%50). Tatil destinasyonlarına odaklı.' },
      { front: 'Emirates hub?', back: 'Dubai (DXB). Dünyanın en büyük A380 filosu. 150+ destinasyon.' },
      { front: 'Qatar Airways ödülü?', back: 'World\'s Best Airline (Skytrax). Doha (DOH) hub. 5 yıldızlı hizmet.' },
      { front: 'Star Alliance üyeleri?', back: 'THY, Lufthansa, United, Singapore Airlines, Air Canada, ANA... 26 havayolu.' },
      { front: 'OneWorld üyeleri?', back: 'Qatar, Emirates YOK! British Airways, Cathay Pacific, Qantas, JAL... 13 havayolu.' }
    ]
  },
  english: {
    name: 'İngilizce',
    emoji: '🇬🇧',
    color: 'from-cyan-500 to-blue-600',
    cards: [
      { front: 'Fasten your seatbelt', back: 'Emniyet kemerinizi bağlayın' },
      { front: 'Cabin crew, prepare for takeoff', back: 'Kabin ekibi, kalkışa hazırlanın' },
      { front: 'We are experiencing turbulence', back: 'Türbülans yaşıyoruz' },
      { front: 'Please remain seated', back: 'Lütfen oturur pozisyonda kalın' },
      { front: 'Overhead compartment', back: 'Üst bagaj dolabı' },
      { front: 'Emergency exit', back: 'Acil çıkış' },
      { front: 'Life vest under your seat', back: 'Can yeleği koltuğunuzun altında' },
      { front: 'We will be landing shortly', back: 'Kısa süre içinde ineceğiz' },
      { front: 'Chicken or fish?', back: 'Tavuk mu balık mı?' },
      { front: 'Would you like some refreshments?', back: 'İçecek ister misiniz?' }
    ]
  }
};

export default function InterviewFlashcards({ onBack }) {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentCard, setCurrentCard] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [knownCards, setKnownCards] = useState([]);
  const [unknownCards, setUnknownCards] = useState([]);
  const [shuffled, setShuffled] = useState(false);
  const [cards, setCards] = useState([]);

  const categories = Object.entries(flashcardsData).map(([key, value]) => ({
    id: key,
    ...value
  }));

  useEffect(() => {
    if (selectedCategory) {
      const categoryCards = [...flashcardsData[selectedCategory].cards];
      if (shuffled) {
        categoryCards.sort(() => Math.random() - 0.5);
      }
      setCards(categoryCards);
      setCurrentCard(0);
      setIsFlipped(false);
    }
  }, [selectedCategory, shuffled]);

  const handleKnown = () => {
    setKnownCards([...knownCards, currentCard]);
    nextCard();
  };

  const handleUnknown = () => {
    setUnknownCards([...unknownCards, currentCard]);
    nextCard();
  };

  const nextCard = () => {
    if (currentCard < cards.length - 1) {
      setCurrentCard(currentCard + 1);
      setIsFlipped(false);
    }
  };

  const prevCard = () => {
    if (currentCard > 0) {
      setCurrentCard(currentCard - 1);
      setIsFlipped(false);
    }
  };

  const resetDeck = () => {
    setCurrentCard(0);
    setIsFlipped(false);
    setKnownCards([]);
    setUnknownCards([]);
  };

  const toggleShuffle = () => {
    setShuffled(!shuffled);
    resetDeck();
  };

  // Category selection screen
  if (!selectedCategory) {
    return (
      <div className="min-h-screen bg-gray-50 pb-8">
        <div className="bg-gradient-to-br from-emerald-600 to-teal-600 px-4 pt-6 pb-8 rounded-b-[2rem]">
          <div className="max-w-4xl mx-auto">
            <button 
              onClick={onBack}
              className="flex items-center gap-2 text-white/80 hover:text-white mb-4"
            >
              <Home className="w-5 h-5" />
              <span className="font-medium">Pratik Merkezi</span>
            </button>
            
            <div className="text-center text-white">
              <BookOpen className="w-12 h-12 mx-auto mb-2 text-yellow-300" />
              <h1 className="text-2xl font-bold">Flashcard'lar</h1>
              <p className="text-emerald-100 text-sm mt-1">Hızlı tekrar ve ezber</p>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 mt-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">Kategori Seç</h2>
          
          <div className="grid grid-cols-2 gap-4">
            {categories.map((category) => (
              <Card 
                key={category.id}
                className="cursor-pointer hover:shadow-lg transition-all hover:scale-[1.02]"
                onClick={() => setSelectedCategory(category.id)}
              >
                <CardContent className="p-4 text-center">
                  <div className={`w-16 h-16 mx-auto rounded-full bg-gradient-to-br ${category.color} flex items-center justify-center mb-3`}>
                    <span className="text-3xl">{category.emoji}</span>
                  </div>
                  <h3 className="font-bold text-gray-900">{category.name}</h3>
                  <p className="text-sm text-gray-500 mt-1">{category.cards.length} kart</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Flashcard view
  const category = flashcardsData[selectedCategory];
  const card = cards[currentCard];
  const progress = ((currentCard + 1) / cards.length) * 100;
  const isComplete = currentCard >= cards.length - 1 && (knownCards.includes(currentCard) || unknownCards.includes(currentCard));

  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      <div className={`bg-gradient-to-br ${category.color} px-4 pt-6 pb-8 rounded-b-[2rem]`}>
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-4">
            <button 
              onClick={() => setSelectedCategory(null)}
              className="flex items-center gap-2 text-white/80 hover:text-white"
            >
              <Home className="w-5 h-5" />
              <span className="font-medium">Kategoriler</span>
            </button>
            
            <div className="flex items-center gap-2">
              <button 
                onClick={toggleShuffle}
                className={`p-2 rounded-full ${shuffled ? 'bg-white text-gray-800' : 'bg-white/20 text-white'}`}
              >
                <Shuffle className="w-4 h-4" />
              </button>
              <div className="bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">
                <span className="text-white font-bold text-sm">{category.name}</span>
              </div>
            </div>
          </div>

          <div className="bg-white/20 rounded-full h-2 mb-2">
            <div 
              className="bg-white rounded-full h-2 transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-white/80 text-sm text-center">
            Kart {currentCard + 1} / {cards.length}
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 mt-6">
        {/* Stats */}
        <div className="flex justify-center gap-4 mb-4">
          <div className="flex items-center gap-2 bg-green-100 px-3 py-1.5 rounded-full">
            <CheckCircle2 className="w-4 h-4 text-green-600" />
            <span className="text-green-700 font-medium text-sm">{knownCards.length} biliyorum</span>
          </div>
          <div className="flex items-center gap-2 bg-red-100 px-3 py-1.5 rounded-full">
            <XCircle className="w-4 h-4 text-red-600" />
            <span className="text-red-700 font-medium text-sm">{unknownCards.length} tekrar</span>
          </div>
        </div>

        {/* Completion Screen */}
        {isComplete ? (
          <Card className="text-center">
            <CardContent className="p-8">
              <div className="text-6xl mb-4">🎉</div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Tebrikler!</h2>
              <p className="text-gray-600 mb-6">Tüm kartları tamamladın!</p>
              
              <div className="flex justify-center gap-4 mb-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-600">{knownCards.length}</div>
                  <div className="text-sm text-gray-500">Biliyorum</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600">{unknownCards.length}</div>
                  <div className="text-sm text-gray-500">Tekrar Gerekli</div>
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <Button onClick={resetDeck} variant="outline" className="w-full">
                  <RotateCw className="w-4 h-4 mr-2" />
                  Baştan Başla
                </Button>
                <Button onClick={() => setSelectedCategory(null)} className="w-full">
                  Diğer Kategoriler
                </Button>
                <Button onClick={onBack} variant="outline" className="w-full">
                  <Home className="w-4 h-4 mr-2" />
                  Pratik Merkezi'ne Dön
                </Button>
              </div>
            </CardContent>
          </Card>
        ) : (
          <>
            {/* Flashcard */}
            <div 
              className="perspective-1000 cursor-pointer mb-4"
              onClick={() => setIsFlipped(!isFlipped)}
            >
              <div className={`relative w-full transition-transform duration-500 transform-style-3d ${isFlipped ? 'rotate-y-180' : ''}`}>
                <Card className={`min-h-[250px] ${isFlipped ? 'invisible' : ''}`}>
                  <CardContent className="p-6 flex flex-col items-center justify-center min-h-[250px]">
                    <h2 className="text-xl font-bold text-gray-900 text-center">{card?.front}</h2>
                    <p className="text-sm text-gray-400 mt-4">Cevabı görmek için tıkla</p>
                  </CardContent>
                </Card>
                
                <Card className={`min-h-[250px] absolute inset-0 rotate-y-180 backface-hidden ${!isFlipped ? 'invisible' : ''}`}>
                  <CardContent className="p-6 flex flex-col items-center justify-center min-h-[250px] bg-gradient-to-br from-green-50 to-emerald-50">
                    <p className="text-lg text-gray-800 text-center">{card?.back}</p>
                  </CardContent>
                </Card>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-between items-center mb-4">
              <Button 
                variant="outline" 
                onClick={prevCard}
                disabled={currentCard === 0}
              >
                <ChevronLeft className="w-4 h-4 mr-1" />
                Önceki
              </Button>
              
              <div className="flex gap-2">
                <Button 
                  variant="outline"
                  className="border-red-300 text-red-600 hover:bg-red-50"
                  onClick={handleUnknown}
                >
                  <XCircle className="w-4 h-4 mr-1" />
                  Bilmiyorum
                </Button>
                <Button 
                  className="bg-green-600 hover:bg-green-700"
                  onClick={handleKnown}
                >
                  <CheckCircle2 className="w-4 h-4 mr-1" />
                  Biliyorum
                </Button>
              </div>
              
              <Button 
                variant="outline" 
                onClick={nextCard}
                disabled={currentCard >= cards.length - 1}
              >
                Sonraki
                <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
          </>
        )}
      </div>

      <style jsx>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .transform-style-3d {
          transform-style: preserve-3d;
        }
        .rotate-y-180 {
          transform: rotateY(180deg);
        }
        .backface-hidden {
          backface-visibility: hidden;
        }
      `}</style>
    </div>
  );
}
